import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridToolbar, GridPageChangeEvent, GridSortChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import ChildAutoComplete, { ChildSearchResult } from '../ChildAutoComplete';
import AccountAutoComplete, { AccountSearchResult } from '../AccountAutoComplete';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import TeacherComboBox, { TeacherSearchResult } from '../TeacherComboBox';
import SchoolComboBox, { SchoolSearchResult } from '../SchoolComboBox';
import CourseAutoComplete, { CourseSearchResult } from '../CourseAutoComplete';
import InstructorComboBox, { InstructorSearchResult } from '../InstructorComboBox';
import { Input } from '@progress/kendo-react-inputs';
import * as moment from 'moment';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type DocumentData = {
    DocumentId: number;
    Name: string;
    Description: string;
    DocumentURL: string;
}

type State = {
    isLoading: boolean;
    skip: number;
    take: number;
    pageSize: number;
    pageable: boolean | GridPagerSettings;
    academicUser: boolean;
    sort: SortDescriptor[];
    documents: DocumentData[];
    searchChild: ChildSearchResult | null;
    searchAccount: AccountSearchResult | null;
    searchTeacher: TeacherSearchResult | null;
    searchSchool: SchoolSearchResult | null;
    searchCourse: CourseSearchResult | null;
    searchInstructor: InstructorSearchResult | null;
    searchGrade: number;
    searchDocument: number;
    searchUnit: number;
    searchTitle: string;
}

const formPaddingLeft = {
    paddingRight: "10px"
} as React.CSSProperties;

class Documents extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            academicUser: false,
            isLoading: false,
            skip: 0,
            take: 50,
            pageSize: 50,
            pageable: this.state ? this.state.pageable : {
                buttonCount: 10,
                info: true,
                type: 'numeric',
                pageSizes: [50, 100, 150],
                previousNext: true
            },
            documents: [],
            sort: [],
            searchChild: null,
            searchAccount: null,
            searchTeacher: null,
            searchSchool: null,
            searchCourse: null,
            searchInstructor: null,
            searchGrade: -1,
            searchDocument: 0,
            searchUnit: 0,
            searchTitle: '',
        };

        this.sortChange = this.sortChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.searchDocuments = this.searchDocuments.bind(this);
        this.upload = this.upload.bind(this);
    }

    public componentWillMount() {
        this.getDocuments();
    }

    private pageChange(event: GridPageChangeEvent) {
        this.setState({
            skip: event.page.skip,
            take: event.page.take,
            pageSize: event.page.take
        });
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            documents: orderBy(this.state.documents, event.sort)
        });
    }

    public render() {
        const grades = [
            {ID: 0, Name: "Kindergarten"},
            {ID: 1, Name: "1"},
            {ID: 2, Name: "2"},
            {ID: 3, Name: "3"},
            {ID: 4, Name: "4"},
            {ID: 5, Name: "5"},
            {ID: 6, Name: "6"},
            {ID: 7, Name: "7"},
            {ID: 8, Name: "8"},
            {ID: 9, Name: "9"},
            {ID: 10, Name: "10"},
            {ID: 11, Name: "11"},
            {ID: 12, Name: "12"}
        ];
        const docTypes = [{ ID: 1, Name: "Account" },{ ID: 2, Name: "Assignment" },{ ID: 3, Name: "Correspondence" },{ ID: 4, Name: "Course Work" },{ ID: 5, Name: "Incident" },{ ID: 6, Name: "Test" }];
        const units = [];
        for (var i = 1; i <= 25; i++)
            units.push({ID: i, Name: i.toString()});
        return <React.Fragment>
            <DocumentTitle title="Documents" />
            <div className="row">
                <div className="col">
                    <h1>Documents</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" onClick={this.upload}>Upload</button>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            <Grid
                style={{ maxHeight: "1000px" }}
                skip={this.state.skip}
                take={this.state.take}
                total={this.state.documents.length}
                pageable={this.state.pageable}
                pageSize={this.state.pageSize}
                onPageChange={this.pageChange}
                sortable={{ allowUnsort: true }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                data={this.state.documents.slice(this.state.skip, this.state.take + this.state.skip)}
            >
                <GridToolbar>
                    <div className="row" style={{ paddingTop: "10px" }}>
                        <div className="col-12">
                            <div className="form-inline">
                                <div className="form-group" style={formPaddingLeft}>
                                    <Input
                                        className="form-control"
                                        style={{ color: '#5b646c', width: "100%" }}
                                        placeholder="Title"
                                        onChange={(e) => this.setState({ searchTitle: e.target.value }, this.searchDocuments)}
                                        value={this.state.searchTitle}
                                    />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <ChildAutoComplete
                                        className="form-control"
                                        style={{ color: '#007bff', width: "100%" }}
                                        classroomId={null}
                                        callbackFromParent={this.myCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <AccountAutoComplete
                                        className="form-control"
                                        style={{ color: '#007bff', width: "100%" }}
                                        callbackFromParent={this.myAccountACCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <InstructorComboBox
                                        className="form-control"
                                        style={{ color: '#007bff', width: "100%" }}
                                        callbackFromParent={this.myInstructorCBCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={{ paddingRight: "10px", width: "20%" }}>
                                    <ComboBox
                                        className="form-control"
                                        textField="Name"
                                        data={docTypes}
                                        placeholder="Document Type"
                                        style={{ color: '#6c757d' }}
                                        onChange={(e) => {this.setState({ searchDocument: (e.target.value == null) ? 0 : e.target.value.ID}, this.searchDocuments)}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.academicUser && <React.Fragment>
                        <div className="row" style={{ paddingTop: "10px" }}>
                            <div className="col-12">
                                <div className="form-inline">
                                    <div className="form-group" style={formPaddingLeft}>
                                        <CourseAutoComplete
                                            className="form-control"
                                            style={{ color: '#007bff', width: "100%", marginTop: "5px" }}
                                            callbackFromParent={this.myCourseCallback.bind(this)} />
                                    </div>
                                    <div className="form-group" style={formPaddingLeft}>
                                        <TeacherComboBox
                                            className="form-control"
                                            style={{ color: '#007bff', width: "100%" }}
                                            callbackFromParent={this.myTeacherCBCallback.bind(this)} />
                                    </div>
                                    <div className="form-group" style={formPaddingLeft}>
                                        <SchoolComboBox
                                            className="form-control"
                                            style={{ color: '#007bff', width: "100%" }}
                                            callbackFromParent={this.mySchoolCBCallback.bind(this)} />
                                    </div>
                                    <div className="form-group" style={{ paddingRight: "10px", width: "15%" }}>
                                        <ComboBox
                                            className="form-control"
                                            textField="Name"
                                            data={grades}
                                            placeholder="Grade Level"
                                            suggest={true}
                                            style={{ color: '#6c757d' }}
                                            onChange={(e) => {this.setState({ searchGrade: (e.target.value == null) ? -1 : e.target.value.ID}, this.searchDocuments)}}
                                        />
                                    </div>
                                    <div className="form-group" style={{ paddingRight: "10px", width: "15%" }}>
                                        <ComboBox
                                            className="form-control"
                                            textField="Name"
                                            data={units}
                                            placeholder="Unit"
                                            suggest={true}
                                            style={{ color: '#6c757d' }}
                                            onChange={(e) => {this.setState({ searchUnit: (e.target.value == null) ? 0 : e.target.value.ID}, this.searchDocuments)}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>}
                </GridToolbar>
                <Column field="Name" title="Title" cell={DocumentNameCell} />
                <Column field="Description" />
                <Column field="CreatedDate" title="Created Date" cell={DocumentCreatedCell} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    myCallback = (result: ChildSearchResult) => {
        this.setState({ searchChild: result }, this.searchDocuments);
    };

    myCourseCallback = (result: CourseSearchResult) => {
        this.setState({ searchCourse: result }, this.searchDocuments);
    };

    myAccountACCallback = (result: AccountSearchResult) => {
        this.setState({ searchAccount: result }, this.searchDocuments);
    };

    myTeacherCBCallback = (result: TeacherSearchResult) => {
        this.setState({ searchTeacher: result }, this.searchDocuments);
    };

    mySchoolCBCallback = (result: SchoolSearchResult) => {
        this.setState({ searchSchool: result }, this.searchDocuments);
    };

    myInstructorCBCallback = (result: InstructorSearchResult) => {
        this.setState({ searchInstructor: result }, this.searchDocuments);
    };

    private upload() {
        this.props.history.push(`/documents/upload`, { childId: 0 });
    }

    private getDocuments() {
        this.setState({ isLoading: true });
        fetchApi('/api/Document/DocumentSearch', { GradeId: -1 }, 'POST')
            .then((response: { AcademicUser: boolean, Documents: DocumentData[]}) => {
                this.setState({ academicUser: response.AcademicUser, documents: response.Documents, isLoading: false });
            });
    }

    private searchDocuments() {
        const data = {
            ChildId: (this.state.searchChild !== null) ? this.state.searchChild.ChildId : 0,
            AccountId: (this.state.searchAccount !== null) ? this.state.searchAccount.AccountId : 0,
            TeacherId: (this.state.searchTeacher !== null) ? this.state.searchTeacher.TeacherId : 0,
            SchoolId: (this.state.searchSchool !== null) ? this.state.searchSchool.SchoolId : 0,
            CourseId: (this.state.searchCourse !== null) ? this.state.searchCourse.CourseId : 0,
            InstructorId: (this.state.searchInstructor !== null) ? this.state.searchInstructor.InstructorId : 0,
            GradeId: this.state.searchGrade,
            DocumentTypeId: this.state.searchDocument,
            UnitId: this.state.searchUnit,
            Title: this.state.searchTitle,
        }

        this.setState({ isLoading: true });
        fetchApi('/api/Document/DocumentSearch', data, 'POST')
            .then((response: { AcademicUser: boolean, Documents: DocumentData[]}) => {
                this.setState({ academicUser: response.AcademicUser, documents: response.Documents, isLoading: false });
            });
    }
}

class DocumentNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link to={`/document/${this.props.dataItem.DocumentId}`}>{this.props.dataItem.Name}</Link>
            </td>
        );
    }
}

class DocumentCreatedCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td><span>{moment.utc(this.props.dataItem.CreatedDate).local().format('MM/DD/YYYY hh:mm a')}</span></td>
        );
    }
}

export default Documents;
